exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Table__Table___CtorL {\n  /* standard table reset */\n  border-collapse: collapse;\n  border-spacing: 0;\n\n  width: 100%;\n\n  font-size: 12px;\n  line-height: 12px;\n  text-align: left;\n}\n\n.Table__Table___CtorL tr {\n  border-bottom: 1px solid rgba(238, 236, 236, 0.3);\n}\n\n.Table__Table___CtorL th,\n.Table__Table___CtorL td {\n  padding: 0.72em;\n  border-bottom: 1px solid rgba(238, 236, 236, 0.3);\n}\n\n.Table__TableSimple___ipoXK th:first-child,\n.Table__TableSimple___ipoXK td:first-child {\n  padding-left: 1.44em;\n}\n", ""]);

// exports
exports.locals = {
	"Table": "Table__Table___CtorL",
	"TableSimple": "Table__TableSimple___ipoXK"
};